module.exports = __webpack_public_path__ + "static/media/white_marker_icon.1cd6e212.svg";